module.exports = __webpack_public_path__ + "img/c-en.c5470644.png";